import { AxiosResponse } from "axios";
import { Base } from "./bases/base.service";

export default class GeneralService {
  public getBanner(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get("banner/get", { params });
  }
  public getCategory(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get("category/get", { params });
  }
  public getTopCourse(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get("dashboard/get/top/courses", { params });
  }
  public getTopRating(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get("dashboard/get/top/ratings", { params });
  }
  public getCodeDetail(code: string): Promise<AxiosResponse<any>> {
    return Base().get(`dashboard/code/${code}`);
  }
  public getTutorial(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get("user-tutorial", { params });
  }
  public completeTutorial(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("user-tutorial/complete", params);
  }
  public submitFeedback(formData: FormData): Promise<AxiosResponse<any>> {
    return Base().post("feedback", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
